import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as R from 'ramda';

import { getOrders, getReturnDocument } from 'reducers/returnProducts';
import { setOrdersSelected } from 'actions/returnProducts';
import { PluginComponent } from 'plugins';
import { SaleDocumentResponse } from 'types/SalesDocument';
import { useBreakpoints } from 'utils/hooks/UI';

import { MobileTable, DesktopTable, SetBulkReturnReasons } from './components';

const ReturnTable = ({ hideReturnReasons = false }) => {
  const dispatch = useDispatch();

  // Document to make the return for, and the rows (original and returns)
  const returnDocument: SaleDocumentResponse = useSelector(getReturnDocument);
  const allRows = useSelector(getOrders);
  const returnableRows = allRows.filter(r => r.remainingAmount > 0);

  const isDesktopView = useBreakpoints().sm;

  const [globalReturnReason, setGlobalReturnReason] = useState<
    undefined | string
  >();

  /**
   * - all: Forcibly updates all rows to this reason
   * - unassigned: Only applies reason to rows which do not have a reason yet
   */
  const [globalReasonRule, setGlobalReasonRule] = useState<
    'all' | 'unassigned'
  >('unassigned');

  // update the reasons based on the criteria
  function applyGlobalReasonCode() {
    dispatch(
      setOrdersSelected(
        Object.fromEntries(
          returnableRows.map(row => [
            row.stableRowID,
            R.assoc(
              'returnReasonID',
              globalReasonRule === 'unassigned'
                ? Number(row.returnReasonID) || globalReturnReason
                : globalReturnReason,
            )(row),
          ]),
        ),
      ),
    );
  }

  return (
    <div>
      <PluginComponent
        hookname="UISetBulkReturnReasons"
        props={{
          hideReturnReasons,
          setGlobalReturnReason,
          applyCodeChange: applyGlobalReasonCode,
          globalReasonRule,
          setGlobalReasonRule,
          globalReturnReason,
        }}
      >
        <SetBulkReturnReasons
          hideReturnReasons={hideReturnReasons}
          changeRowsReturnReason={setGlobalReturnReason}
          applyCodeChange={applyGlobalReasonCode}
          globalReasonRule={globalReasonRule}
          setGlobalReasonRule={setGlobalReasonRule}
          globalReturnReason={globalReturnReason}
        />
      </PluginComponent>

      <PluginComponent
        hookname="UIReturnTableExtraData"
        props={{
          returnDocument,
        }}
      />
      {isDesktopView ? (
        <DesktopTable
          hideReturnReasons={hideReturnReasons}
          globalReturnReason={globalReturnReason}
        />
      ) : (
        <MobileTable globalReturnReason={globalReturnReason} />
      )}
    </div>
  );
};

export default ReturnTable;
